import React, { useState, useEffect } from 'react';
import feedbackTabOption from './FeedBack.json';
import TabPanel from './TabPanel';
import FeedbackSetupMaster from './FeedbackSetupMaster';
import {
  Grid,
  AppBar,
  makeStyles,
  Box,
  Toolbar,
  Typography,
  Tab,
  Tabs,
} from '@material-ui/core';

const FeedbackSetup = () => {
  const useStyles = makeStyles((theme) => ({
    breadCrumbWrapper: {
      margin: '15px 0',
    },
    header: {
      background: '#ffffff',
      color: theme.palette.KenColors.primary,
      marginTop: '10px',
    },
    title: {
      fontSize: 18,
      fontWeight: 600,
    },
    holidayButton: {
      textTransform: 'none',
      fontWeight: 'bold',
      marginRight: '5px',
    },
    fitlerButton: {
      textTransform: 'none',
      fontWeight: 'bold',
    },
    sortingSection: {
      display: 'grid',
      gap: '10px',
      gridTemplateColumns: 'repeat(7, 1fr)',
    },
    mainActions: {
      textAlign: 'right',
    },
    popOverHeading: {
      width: '100%',
      fontSize: '14px',
      fontWeight: '400',
      color: '#02195E',
    },
    tableBodyStyle: {
      fontSize: '12px',
      color: '#7A869A',
    },
    tableBodyStyleIgnoreHoliday: {
      fontSize: '12px',
      color: '#7A869A',
      padding: '0px',
    },
    textInputFieldDropDown: {
      background: 'transparent',
      borderRadius: '4px',
      color: '#000',
    },
    textInputField: {
      background: 'transparent',
      borderRadius: '4px',
      color: '#000',
    },
    kenDateTimePickerColor: {
      backgroundColor: '#fff',
    },
  }));
  const classes = useStyles();

  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <div position="static" elevation={0} className={classes.header}>
        <Toolbar style={{ minHeight: '45px' }}>
          <Typography className={classes.title}>Feedback setup</Typography>
        </Toolbar>
      </div>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: '24px' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          className={classes.header}
        >
          {feedbackTabOption.feedbackTabOptions.length > 0 &&
            feedbackTabOption.feedbackTabOptions?.map((criteriaName) => {
              return <Tab label={criteriaName.name} />;
            })}
        </Tabs>
      </Box>

      {feedbackTabOption.feedbackTabOptions.map((criteriaName, index) => {
        return (
          <TabPanel value={value} index={index}>
            <FeedbackSetupMaster
              feedbackName={criteriaName.name}
              value={value}
            />
          </TabPanel>
        );
      })}
    </Box>
  );
};

export default FeedbackSetup;
